import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { t } from '../locales/translate.js';

function Element({ apiCall, user, selectedDepot, setSelectedDepot }) {

  const [reports, setReports] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [depots, setDepots] = useState([]);
  const [alsoTransport, setAlsoTransport] = useState(false);

  useEffect(() => {
    console.log("Selected Depot changed:", selectedDepot);
    // Fetch reports data when the component mounts
    error && setError(null); // Reset error state
    let data = {};
    if (selectedDepot && selectedDepot !== "all") {
      data.depot = selectedDepot;
    }
    
    if (user?.id) {
      apiCall("GET", "reports", { depot: selectedDepot })
        .then(({ response, error }) => {
          if (error) {
            console.error("Error fetching reports:", error);
            setError(t('failed_to_fetch_reports'));
          } else {
            setReports(response || []);
          }

        });
    }

    refreshDepots();
 // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiCall, selectedDepot]);

  const refreshDepots = () => {

    apiCall("GET", "transport-depots")
      .then(({ response, error }) => {
        if (error) {
          console.error("Error fetching depots:", error);
          setError(error);
        } else {
          setDepots(response || []);
        }
      });
  };


  const transportAction = (action, reportId) => {
    // Reset success and error states
    setSuccess(null);
    setError(null);

    // Perform the action on the report pickup or scrap
    apiCall("POST", `reports/${reportId}/transport`, { action })
      .then(({ response, error }) => {
        if (error) {
          console.error("Error performing transport action:", error);
          setError(t('failed_transport_action'));
        } else {
          // Handle successful transport action
          console.log("Transport action successful:", response);

          if (action === 'flag') {
            // If the action is 'flag', we might want to keep the report in the list but toggle the flag status
            setReports(prevReports =>
              prevReports.map(report =>
                report.id === reportId ? { ...report, flagged: !report.flagged } : report
              )
            );

          } else if (action === 'transported_by_depot') {
            setReports(prevReports =>
              prevReports.map(report =>
                report.id === reportId ? { ...report, transported_by_depot: !report.transported_by_depot } : report
              )
            );

          } else {

            // update the reports list, without the report that was just acted upon
            setReports(prevReports =>
              prevReports.filter(report => report.id !== reportId)
            );

            refreshDepots();
          }
        }
      });
  };

  const actionWithSelected = (action) => {
    setSuccess(null);
    setError(null);
    // Perform the action on selected reports
    const selectedReports = reports.filter(report => report.selected);
    if (selectedReports.length === 0) {
      setError(t('no_reports_selected'));
      return;
    }

    // perform action on each selected report
    const promises = selectedReports.map(report =>
      apiCall("POST", `reports/${report.id}/transport`, { action, alsoTransport })
    );


    Promise.all(promises)
      .then(responses => {
        const errors = responses.filter(res => res.error);
        if (errors.length > 0) {
          console.error("Error performing transport action on selected reports:", errors);
          setError(t('failed_transport_action_some'));
        } else {
          
          // remove the selected reports from the list
          setReports(prevReports =>
            prevReports.filter(report => !report.selected)
          );
        }
      })
      .catch(err => {
        console.error("Error performing transport action on selected reports:", err);
        setError(t('failed_transport_action_selected'));
      });
    
  }

  // Render the list of reports
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5>{t('transport_reports')}</h5>

        <div className="dt-length d-inline-block dropdown-product">
          <select name="depots" aria-controls="roles-permission" className="dt-input form-select" onChange={(e) => {
            setSelectedDepot(e.target.value);
          }}>
            <option value="all">{t('all_depots')}</option>
            {depots.map(depot => (
              <option key={depot.id} value={depot.id} selected={depot.id == selectedDepot}>{depot.name} ({depot.reports_count})</option>
            ))}
          </select>
        </div>

        <div className="actions">
          <span
            className={`btn ${reports.some(report => report.selected) ? 'btn-success' : 'btn-table'}`}
            onClick={() => actionWithSelected('pickup')}
          >
            <i className="fa-solid fa-check"></i> {t('check_in_selected')}
          </span>

          <label className="ms-4" style={{ cursor: 'pointer' }}>
            <input type="checkbox" className="dt-select-checkbox" onChange={(e) => setAlsoTransport(e.target.checked)} checked={alsoTransport} /> {t('also_transport')}
          </label>

        </div>

        <div className="actions">
          <Link to="/add" className="btn btn-primary">
            <i className="fa-solid fa-plus"></i> {t('new_report')}
          </Link>
        </div>

      </div>

      <div className="card-body projects-wrapper" >
        <div className="row g-4">
          {!reports.length && !user?.id && (
            <div className="col-12">
              {t('no_reports_available_register_or_signin')}
            </div>
          )}

          {success && (
            <div className="col-12">
              <div className="alert alert-success">
                {success}
              </div>
            </div>
          )}

          {error && (
            <div className="col-12">
              <div className="alert alert-danger">
                {error}
              </div>
            </div>
          )}

          {!reports.length && user?.id && (
            <div className="col-12">
              {t('no_reports_available')}
            </div>
          )}


          <div className="container-fluid user-list-wrapper transport-wrapper">
            <div className="row">
              <div className="col-12">
                <div className="list-product user-list-table">
                  <div className="table-responsive custom-scrollbar">
                    <div id="roles-permission_wrapper" className="dt-container dt-empty-footer"><div className="dt-layout-row"><div className="dt-layout-cell dt-start "><div className="dt-length">
                      <label htmlFor="dt-length-0">{t('entries_per_page')}</label></div></div><div className="dt-layout-cell dt-end "></div></div><div className="dt-layout-row dt-layout-table"><div className="dt-layout-cell "><table className="table dataTable" id="roles-permission" aria-describedby="roles-permission_info"><colgroup><col /><col /><col /><col /><col /><col /><col /></colgroup>
                        <thead>
                          <tr role="row">
                            <th data-dt-column="0" rowspan="1" colspan="1" className="dt-select dt-orderable-none" aria-label=""><span className="dt-column-title"></span><span className="dt-column-order"></span>
                              <input className="dt-select-checkbox" type="checkbox" name="select-all" checked={reports.every(report => report.selected)} onChange={() => {
                                const allSelected = reports.every(report => report.selected);
                                setReports(prevReports =>
                                  prevReports.map(report => ({ ...report, selected: !allSelected }))
                                );
                              }} />
                            </th>
                            <th data-dt-column="1" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc dt-ordering-asc" aria-sort="ascending" tabindex="0">
                              <span className="dt-column-title" role="button">
                                <span className="c-o-light f-w-600">{t('code')}</span>
                              </span>
                            </th>
                            <th data-dt-column="2" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc" tabindex="0"><span className="dt-column-title" role="button"> <span className="c-o-light f-w-600">{t('game')}</span></span></th>
                            <th data-dt-column="3" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc flag-col" tabindex="0"><span className="dt-column-title" role="button"> <span className="c-o-light f-w-600"></span></span></th>
                            <th data-dt-column="6" rowspan="1" colspan="1" className="dt-orderable-asc dt-orderable-desc actions-col" tabindex="0"><span className="dt-column-title" role="button"> <span className="c-o-light f-w-600">{t('actions')}</span></span></th></tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, index) => (
                            <tr className="product-removes inbox-data" key={index} role="row" data-id={report.id}>
                              <td className="dt-select">
                                <input aria-label="Select row" className="dt-select-checkbox" type="checkbox" name="selected" checked={report.selected || false} onChange={() => {
                                  setReports(prevReports =>
                                    prevReports.map(r =>
                                      r.id === report.id ? { ...r, selected: !r.selected } : r
                                    )
                                  );
                                }} />
                              </td>
                              <td className="sorting_1 organs_col">
                                <span className="c-o-dark f-w-600">{report.game_qr}</span>
                                {report.organ_qr && ( <i className="fa-solid fa-heart"></i>)}
                              </td>
                              <td>
                                {report.game_name}
                              </td>

                              <td className="flag-col" onClick={() => transportAction('flag', report.id)}>
                                {report?.flagged > 0 ? (
                                  <i className="fa-solid fa-flag active"></i>
                                ) : (
                                  <i className="fa-solid fa-flag not-active"></i>
                                )}
                              </td>
                              <td className="actions-col">
                                <div className="common-align gap-2 justify-content-start actions-cont">
                                  <span className="btn btn-table" onClick={() => transportAction('pickup', report.id)}>
                                     {t('check_in')}
                                  </span>
                                  <Link className="btn btn-table red" to={`/reports/${report.id}/scrap`}>
                                   {t('scrap')}
                                  </Link>
                                </div>
                              </td>
                            </tr>))}
                        </tbody>
                        <tfoot></tfoot></table></div></div>
                      <div className="dt-layout-row"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>

      </div>
    </div>

  );
}

export default Element;
